export default __webpack_public_path__ + "static/media/netvrk-v2-2.d85c2a99.jpg";